import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_HF4_HOMEWORK_REQUEST = 'FETCH_HF4_HOMEWORK_REQUEST';
export const FETCH_HF4_HOMEWORK_SUCCESS = 'FETCH_HF4_HOMEWORK_SUCCESS';
export const FETCH_HF4_HOMEWORK_FAILURE = 'FETCH_HF4_HOMEWORK_FAILURE';

const buildHF4HomeworkUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/hf4/homework`);
const HTTP_METHOD_GET = 'GET';

export function fetchHF4HomeworkIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    const url = buildHF4HomeworkUrl(sessionId);
    if (! ApiCall.shouldPerform(state, { method: HTTP_METHOD_GET, url })) {
      return false;
    }

    return dispatch(fetchHF4Homework(sessionId));
  };
}

export function fetchHF4Homework(sessionId) {
  return (dispatch) => {
    const url = buildHF4HomeworkUrl(sessionId);
    const method = HTTP_METHOD_GET;

    return dispatch(createHF4HomeworkRequestAction({ sessionId, method, url })).payload
      .then((response) => dispatch(createHF4HomeworkSuccessAction({ response, sessionId, method, url })))
      .catch((error) => {
        if (error.response && error.response.code === 404) {
          return dispatch(createHF4HomeworkSuccessAction({ sessionId, method, url }));
        }

        return dispatch(createHF4HomeworkFailureAction({ error, sessionId, method, url }));
      });
  };
}

function createHF4HomeworkRequestAction({ sessionId, method, url }) {
  return ApiCall.createAction({
    type: FETCH_HF4_HOMEWORK_REQUEST,
    payload: fetch(url),
    url,
    method,
    sessionId,
  });
}

function createHF4HomeworkSuccessAction({ response, sessionId, method, url }) {
  return ApiCall.createAction({
    type: FETCH_HF4_HOMEWORK_SUCCESS,
    payload: response,
    url,
    method,
    sessionId,
  });
}

function createHF4HomeworkFailureAction({ error, sessionId, method, url }) {
  return ApiCall.createAction({
    type: FETCH_HF4_HOMEWORK_FAILURE,
    error,
    url,
    method,
    sessionId,
  });
}


// WEBPACK FOOTER //
// ./data/HF4Homework/actions.js